<template>
  <div @click="$emit('input', !value)" class="locomotive-scroll-modal" :class="value ? 'active' : false"

  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'LocoModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (window.locoScroll) {
          if (val) window.locoScroll.stop()
          else window.locoScroll.start()
        }
      }
    }
  },
  mounted() {
    document.body.insertBefore(this.$el, document.body.firstChild)
  }
}
</script>

<style scoped lang="scss">
.locomotive-scroll-modal::v-deep {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100000;
  visibility: hidden;
  opacity: 0;

  &.active {
    visibility: visible;
    background-color: rgba(0, 0, 0, .6);
    opacity: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
